import { distanceKm } from './tripAwareLabels';
import { PRIMARY_LOCAL_RADIUS_KM, FALLBACK_LOCAL_RADIUS_KM } from '../config/whatsOnDiscovery';

const usable = point => Number.isFinite(point?.lat) && Number.isFinite(point?.lng)
  && Math.abs(point.lat) <= 90 && Math.abs(point.lng) <= 180;
export function activeDiscoveryCenter(device, home) {
  if (usable(device)) return { ...device, kind: 'device' };
  if (usable(home)) return { ...home, kind: 'home' };
  return { kind: 'none' };
}

/**
 * Whether the list is fenced somewhere other than home: the device's centre,
 * and home either not within the primary circle of it or with no coordinates
 * to tell. A list titled "in <home city>" must not be fenced anywhere else.
 */
export function isAwayFromHome(center, home) {
  if (center?.kind !== 'device') return false;
  const distance = distanceKm(center.lat, center.lng, home?.lat, home?.lng);
  return distance == null || distance > PRIMARY_LOCAL_RADIUS_KM;
}

/** Defensive, independently testable circle partition. SQL also applies this
 * before LIMIT, so rejected corners cannot steal legitimate candidates' slots.
 */
export function discoveryCohorts(items, center) {
  const primary = [], farther = [], global = [];
  for (const item of items || []) {
    const distance = center.kind === 'none' ? null : distanceKm(
      center.lat, center.lng, item.latitude ?? item.lat, item.longitude ?? item.lng);
    let band;
    if (center.kind === 'none') band = 'global';
    else if (distance == null || distance > FALLBACK_LOCAL_RADIUS_KM + 1e-7) continue;
    else band = distance <= PRIMARY_LOCAL_RADIUS_KM + 1e-7 ? 'primary' : 'farther';
    const row = { ...item, _recommendation: {
      origin: band === 'global' ? 'global' : band === 'primary' ? 'local' : 'farther',
      centerKind: center.kind, distanceBand: band, distanceKm: distance,
      provider: typeof item.source === 'string' ? item.source : item.source_type || null
    } };
    ({ primary, farther, global })[band].push(row);
  }
  return { primary, farther, global };
}

export function explainFollow(item, center, home) {
  const source = item.follow_source;
  const homeDistance = distanceKm(home?.lat, home?.lng, item.latitude, item.longitude);
  const away = center.kind === 'device'
    && distanceKm(center.lat, center.lng, home?.lat, home?.lng) > PRIMARY_LOCAL_RADIUS_KM;
  return { ...item, _recommendation: {
    origin: source?.kind === 'artist' ? 'followed_artist' : 'followed_venue',
    centerKind: center.kind, distanceBand: 'follow',
    nearHomeWhileAway: !!(away && homeDistance != null && homeDistance <= FALLBACK_LOCAL_RADIUS_KM),
    provider: typeof item.source === 'string' ? item.source : item.source_type || null
  } };
}
